var map = {
	"./Graphical_abstract-NTPDase3.jpg": 78,
	"./Graphical_abstract-NTPDase3_thb.jpg": 79,
	"./Graphical_abstract-T1D.jpg": 80,
	"./Graphical_abstract-T1D_thb.jpg": 81,
	"./humanislets-Figure7-L.jpg": 82,
	"./humanislets-Figure7.jpg": 83,
	"./insulinresistance-Figure6-L.jpg": 84,
	"./insulinresistance-Figure6.jpg": 85,
	"./isletgrowth-Figure5-L.jpg": 86,
	"./isletgrowth-Figure5.jpg": 87,
	"./transplantation-Figure8-L.jpg": 88,
	"./transplantation-Figure8.jpg": 89,
	"./vascularization-Figure4-L.jpg": 90,
	"./vascularization-Figure4.jpg": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;